<template>
  <div class="container">
    <div class="header">
      <div class="headCon">
        <div class="hand">
          <div class="logo">
            <img src="../../assets/image/logo.png" alt="" />
          </div>
          <!-- <div class="go-old">
          <button @click="goOld">2020年度培训登录</button>
        </div> -->
        </div>
        <div class="headRight">
          <div class="nav-bar">
            <ul class="nav">
              <li
                v-for="item in head"
                @click="gos(item)"
                :class="actives == item.name ? 'actives' : 'ss'"
                :key="item.name"
              >
                <a href="#">{{ item.name }}</a>
              </li>
            </ul>
          </div>
          <div class="info" v-if="user">
            <div class="user" @click="$router.push('/person')">
              <img src="../../assets/icon/user.png" alt="" />
              <div class="finso">
                <p class="resf">个人中心</p>
                <span>{{ userInfo.userMobile }}</span>
              </div>
            </div>
            <div
              class="message"
              @click="$router.push('/message')"
              style="cursor: pointer"
            >
              <img
                src="../../assets/icon/message.png"
                width="30px"
                height="30px"
                alt=""
              />
              <span>消息</span>
            </div>
            <div class="logout" @click="logout">
              <img src="../../assets/icon/logout.png" alt="" />
              <span>退出</span>
            </div>
          </div>
          <div class="infos" v-else>
            <span @click="dialogFormVisible2 = true" style="cursor: pointer"
              >登录 | 注册</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <router-view />
    </div>
    <div class="footer">
      <div class="footer-content">
        <div class="left">
          <p class="title">中财国培教育科技有限公司</p>
          <ul>
            <li>
              <a href="http://www.mof.gov.cn" target="_blank">财政部</a>
            </li>
            <li>
              <a href="http://www.cfemg.cn" target="_blank"
                >中国财经出版传媒集团</a
              >
            </li>
            <li>
              <a href="http://www.fegph.cn/z/13/" target="_blank"
                >中国政府采购</a
              >
            </li>
            <li><a href="http://zgcj.cfefe.com/#/index" target="_blank">财会专题</a></li>
            <li><a>关于我们</a></li>    
            <li style="cursor: pointer">
              <a @click="$router.push('/advise')">意见反馈</a>
            </li>
          </ul>
        </div>
        <div class="qrcon">
          <div class="qr">
            <img
              src="../../assets/image/qr4.jpg"
              height="100px"
              width="100px"
              alt=""
            />
            <span>中国政府采购杂志社微店</span>
          </div>
          <div class="qr">
            <img
              src="../../assets/image/qr3.png"
              height="100px"
              width="100px"
              alt=""
            />
            <span>中国政府采购杂志</span>
          </div>
          <div class="qr">
            <img
              src="../../assets/image/qr2.png"
              height="100px"
              width="100px"
              alt=""
            />
            <span>微信客服</span>
          </div>
          <div class="qr">
            <img
              src="../../assets/image/qr.png"
              height="100px"
              width="100px"
              alt=""
            />
            <span>扫码关注公众号</span>
          </div>
        </div>
      </div>
    </div>

    <div class="filings">
      <span
        >备案号：京ICP备16046365号-2 联系方式：010-88583040/13051266356
        地址：北京市海淀区阜成路甲28号</span
      >
    </div>

    <el-dialog
      title="您好！欢迎注册"
      width="540px"
      center
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      :modal-append-to-body="false"
      custom-class="redege"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item prop="userMobile">
          <el-input
            v-model="form.userMobile"
            prefix-icon="el-icon-mobile-phone"
            placeholder="请输入手机号"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="form.code"
            prefix-icon="el-icon-chat-dot-square"
            placeholder="请输入短信验证码"
            autocomplete="off"
          >
            <el-button slot="append" @click="getCode">{{
              !show ? "随机验证码" : message
            }}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="form.password"
            prefix-icon="el-icon-lock"
            placeholder="设置登录密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password2">
          <el-input
            type="password"
            v-model="form.password2"
            prefix-icon="el-icon-lock"
            placeholder="再次确认登录密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="userName">
          <el-input
            type="text"
            v-model="form.userName"
            prefix-icon="el-icon-user"
            placeholder="请输入真实姓名"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="userCompany">
          <el-input
            type="text"
            v-model="form.userCompany"
            prefix-icon="el-icon-office-building"
            placeholder="请输入工作单位"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="userEmail">
          <el-input
            type="text"
            v-model="form.userEmail"
            prefix-icon="el-icon-message"
            placeholder="请输入电子邮箱"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="userGender">
          <el-select
            v-model="form.userGender"
            style="width: 100%"
            placeholder="请选择性别"
          >
            <el-option label="男" value="男"> </el-option>
            <el-option label="女" value="女"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="checked">
          <el-checkbox v-model="form.checked"
            ><span style="font-size: 12px; color: #888888"
              >我已阅读并同意中财国培</span
            ><span style="color: #264f99; font-size: 12px" @click="look"
              >《用户注册协议》、</span
            ><span style="color: #264f99; font-size: 12px" @click="look2"
              >《隐私政策》</span
            ></el-checkbox
          >
        </el-form-item>
        <el-form-item>
          <el-button
            style="width: 100%; background: #264f99; color: #fff"
            @click="signUp('form')"
            >注册</el-button
          >
        </el-form-item>
        <!-- <el-form-item> -->
        <span
          style="
            display: block;
            color: #888888;
            text-align: center;
            cursor: pointer;
          "
          @click="login"
          >已有账号，去登录</span
        >
        <!-- </el-form-item> -->
      </el-form>
    </el-dialog>
    <el-dialog
      width="450px"
      center
      :visible.sync="dialogFormVisible2"
      :close-on-click-modal="false"
      custom-class="redege"
    >
      <div
        style="
          display: flex;
          justify-content: space-around;
          margin-bottom: 43px;
          margin-top: -10px;
        "
      >
        <span
          :class="active === '账户登录' ? 'active' : 'active2'"
          @click="active = '账户登录'"
          >账户登录</span
        >
        <span
          :class="active === '快捷登录' ? 'active' : 'active2'"
          @click="active = '快捷登录'"
          >快捷登录</span
        >
      </div>
      <el-form
        :model="form2"
        :rules="rules2"
        ref="form2"
        style="margin-top: 20px"
        v-show="active === '账户登录'"
      >
        <el-form-item prop="userName">
          <el-input
            v-model="form2.userName"
            prefix-icon="el-icon-mobile-phone"
            placeholder="请输入手机号"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="form2.password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div style="display: flex; justify-content: space-between">
            <el-checkbox v-model="form2.checked">记住密码</el-checkbox>
            <span style="cursor: pointer" @click="forget">忘记密码？</span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            style="width: 100%; background: #264f99; color: #fff"
            :loading="loginLoading"
            @click="signIn('form2')"
            >登录</el-button
          >
        </el-form-item>

        <span
          style="
            display: block;
            color: #888888;
            text-align: center;
            cursor: pointer;
          "
          @click="register"
          >还没有账号，去注册</span
        >
      </el-form>
      <el-form
        :model="form3"
        :rules="rules3"
        ref="form3"
        style="margin-top: 20px"
        v-show="active === '快捷登录'"
      >
        <el-form-item prop="userMobile">
          <el-input
            v-model="form3.userMobile"
            prefix-icon="el-icon-mobile-phone"
            placeholder="请输入手机号"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="form3.code"
            prefix-icon="el-icon-chat-dot-square"
            placeholder="请输入短信验证码"
            autocomplete="off"
          >
            <el-button slot="append" @click="getCode2">{{
              !show2 ? "随机验证码" : message2
            }}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            style="width: 100%; background: #264f99; color: #fff"
            @click="kjSignIn('form3')"
            >登录</el-button
          >
        </el-form-item>

        <span
          style="
            display: block;
            color: #888888;
            text-align: center;
            cursor: pointer;
          "
          @click="register"
          >还没有账号，去注册</span
        >
      </el-form>
    </el-dialog>
    <el-dialog width="50%" :visible.sync="dialogVisible">
      <h3 style="font-size: 28px">中财国培在线培训平台用户注册协议</h3>
      <span></span>
      <div>
        <p>特别提示：</p>
        <p>
          欢迎您与中财国培在线培训平台（中财国培教育科技有限公司）共同签署本《中财国培在线培训平台用户注册协议》（下称“协议”）并使用中财国培在线培训平台服务！
          本协议为《中财国培在线用户注册协议》修订版本，自本协议发布之日起，中财国培在线培训平台各处所称“注册协议”均指本协议。
        </p>

        1．中财国培在线培训平台同意按照本协议的规定及其不时发布的操作规则提供基于互联网以及移动网的相关服务（以下称“网络服务”），为获得网络服务，服务使用人（以下称“用户”）应当同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。<br />
        2.
        用户注册成功后，中财国培在线将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。<br />
        <p>
          特别告知：在成为中财国培的注册用户后，平台将根据用户的实际情况同用户取得联系并进行沟通。沟通的途径是用户注册时所用的手机号码，沟通的内容包含但不限于让用户更好地使用平台，如何获取平台的产品，以及用户有可能在使用过程中遇到的问题等。在沟通过程中，如果用户明确表示拒绝，则平台将终止沟通。
        </p>

        注册成为平台用户，则表示注册人用实际行动同意平台与其取得沟通的做法，对此事项不存在任何异议。<br />
        一、服务内容 <br />
        1、中财国培在线网络服务的具体内容由中财国培在线培训平台根据实际情况提供，例如培训项目、报名等。<br />
        2、中财国培在线培训平台提供的部分网络服务如培训项目等，为收费的网络服务，用户使用收费网络服务需要向中财国培在线培训平台支付一定的费用。对于收费的网络服务，中财国培在线培训平台会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用该收费网络服务。如用户拒绝支付相关费用，则中财国培在线培训平台有权不向用户提供该等收费网络服务。<br />
        3、用户告知，中财国培在线培训平台提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。
        <br />
        二、服务变更、中断或终止 <br />
        1、鉴于网络服务的特殊性，用户同意中财国培在线培训平台有权随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。如变更、中断或终止的网络服务属于免费网络服务，中财国培在线培训平台无需通知用户，也无需对任何用户或任何第三方承担任何责任；如变更、中断或终止的网络服务属于收费网络服务，中财国培在线培训平台应当在变更、中断或终止之前事先通知用户，并应向受影响的用户提供等值的替代性的收费网络服务，如用户不愿意接受替代性的收费网络服务，就该用户已经向中财国培在线培训平台支付的服务费，中财国培在线培训平台应当依照法律规定决定是否给用户进行退还。不能够退还的，中财国培在线将给出合法、合理的解释；能够退还的，中财国培在线培训平台将按照该用户实际使用相应收费网络服务的情况扣除相应服务费之后将剩余的服务费退还给该用户。<br />
        2、用户告知，中财国培在线培训平台需要定期或不定期地对提供网络服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，中财国培在线培训平台无需为此承担任何责任，但中财国培在线培训平台应尽可能事先进行通告。
        <br />
        3、如发生下列任何一种情形，中财国培在线培训平台有权随时中断或终止向用户提供本协议项下的网络服务（包括收费网络服务）而无需对用户或任何第三方承担任何责任：
        <br />
        3.1 用户提供的个人资料不真实； <br />
        3.2 用户违反本协议中规定的使用规则； <br />
        3.3
        用户在使用收费网络服务时未按规定向中财国培在线培训平台支付相应的服务费。<br />
        三、使用规则 <br />
        1、用户在申请使用中财国培在线培训平台网络服务时，必须向中财国培在线培训平台提供必要的准确的个人资料，如个人必要资料有任何变动，请务必及时更新。<br />
        2、中财国培在线培训平台账号所有权归中财国培教育科技有限公司所有，用户仅拥有中财国培在线培训平台账号的有限使用权。用户需对其享有使用权的账号下所从事的所有行为承担责任，用户应妥善保管自己的账号、密码，不得将中财国培在线培训平台账号转让、出借、出租、售卖或分享予他人使用，否则中财国培在线培训平台有权选择根据实际情况暂时封停或永久查封此账号。当用户的账号或密码遭到未经授权的使用时，用户应当立即通知中财国培在线培训平台，否则未经授权的使用行为均视为用户本人的行为。中财国培在线培训平台为了保障用户的账号安全可能会定期或不定期采用不同的方式对用户的身份进行验证，包括但不限于要求输入验证码、短消息验证、人脸识别等。如用户无法完成验证或拒绝验证的，中财国培在线培训平台可合理怀疑用户的账号出现异常或被盗，并暂停向用户提供产品与服务或采取进一步措施。因黑客行为或用户的保管疏忽导致账号、密码遭他人非法使用，中财国培在线培训平台不承担任何责任。<br />
        3、用户同意中财国培在线培训平台有权在提供网络服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在中财国培在线培训平台的任何页面上投放广告），并且，用户同意接受中财国培在线培训平台通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。<br />
        4、 用户在使用中财国培在线培训平台网络服务过程中，必须遵循以下原则：<br />
        4.1
        用户在使用中财国培在线培训平台的产品与服务过程中，应遵守宪法法律，包括但不限于《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》、《网络安全法》等有关计算机及互联网规定的法律、法规；应遵守公共秩序，尊重社会公德，不得危害网络安全，不得利用网络从事危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度，煽动分裂国家、破坏国家统一，宣扬恐怖主义、极端主义，宣扬民族仇恨、民族歧视，传播暴力、淫秽色情信息，编造、传播虚假信息扰乱经济秩序和社会秩序，以及侵害他人名誉、隐私、知识产权和其他合法权益等活动。在任何情况下，中财国培在线培训平台一旦合理地认为用户存在上述行为的，可以在任何时候，不经事先通知终止向该用户提供产品与/或服务；<br />
        4.2 遵守所有与网络服务有关的网络协议、规定和程序；<br />
        4.3 不得为任何非法目的而使用网络服务系统；<br />
        4.4
        不得以任何形式使用中财国培在线培训平台网络服务侵犯平台的商业利益，包括并不限于发布非经中财国培在线培训平台许可的商业广告；<br />
        4.5
        不得利用中财国培在线培训平台网络服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；<br />
        4.6
        不得利用中财国培在线培训平台提供的网络服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法信息资料；<br />
        4.7
        不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益；<br />
        4.8
        不得利用中财国培在线培训平台网络服务系统进行任何不利于中财国培在线培训平台的行为；<br />
        5、中财国培在线培训平台有权对用户使用中财国培在线培训平台服务的情况进行审查和监督。如用户在使用网络服务时违反任何上述规定，中财国培在线培训平台或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容等、暂停或终止用户使用网络服务的权利）以减轻用户不当行为造成的影响。<br />
        6、中财国培在线培训平台针对某些特定的中财国培在线培训平台服务的使用通过各种方式（包括但不限于网页公告、电子邮件、短信提醒等）作出的任何声明、通知、警示等内容视为本协议的一部分，用户如使用该等中财国培在线培训平台网络服务，视为用户同意该等声明、通知、警示的内容。<br />
        7、凡用户昵称中出现如下信息者（包括但不限于），中财国培在线培训平台有权进行屏蔽、锁定，甚至注销：<br />
        7.1
        使用严重违反国家法律法律及风序良俗，包含或暗藏反动、色情等信息（含符号、地址等）的昵称；<br />
        7.2
        使用党和国家领导人、古今中外比较有影响的名人、网络上知名人士的真实姓名、字、号、艺名、笔名、头衔等为昵称；<br />
        7.3 使用国家机构、企事业单位、知名公司或品牌的名称及标识为昵称；<br />
        7.4 含性别歧视、种族歧视、地域歧视等信息的昵称；<br />
        7.5
        含自侮辱、猥亵或者对他人进行侮辱、挑衅、漫骂、人身攻击等不文明、不健康信息的昵称；<br />
        7.6 含易产生歧义、引起他人误解的信息的昵称；<br />
        7.7
        未获得中财国培在线培训平台官方正式许可而使用带有中财国培在线培训平台名称的昵称；<br />
        7.8 带有明显广告性质的昵称；<br />
        7.9 带有其它法律法规以及平台禁止规则中所包含信息的昵称。<br />
        四、知识产权<br />
        1、受国际版权公约、中华人民共和国著作权法、专利法、及其他知识产权方面的法律法规的保护，中财国培在线培训平台的产品与服务及所使用的软件、界面、交互等元素、LOGO、商标、标识、图形、文字、音频、视频、肖像、图片、技术等的所有知识产权归中财国培在线培训平台所有和享有。“知识产权”包括在专利法、版权法、商标法、反不正当竞争法中等法律规定的任何和所有权利、任何和所有其它所有权以及其中的任何和所有应用、更新、扩展和恢复。<br />
        2、中财国培在线培训平台为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图象、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于中财国培教育科技有限公司，未经该软件权利人的许可，用户不得对该软件进行反向工程（reverse
        engineer）、反向编译（decompile）或反汇编（disassemble）。<br />
        3、用户只能在本协议以及中财国培在线培训平台明示授权的范围内容使用中财国培在线培训平台提供的产品与服务。未经中财国培在线培训平台事先书面许可，用户不得以任何营利性或非营利性的目的修改、复制、传播、传送、发行、转移、销售中财国培在线培训平台产品与服务所使用的软件、技术、材料以及产品与服务内容等或创造、制作与这些内容有关的派生产品或衍生品。否则，用户自行承担因此而造成对中财国培在线培训平台或其他人的全部损害。<br />
        4、中财国培在线培训平台对其自制内容和其他通过授权取得的独占内容享有完全知识产权，未经中财国培在线培训平台许可，任何单位和个人不得私自转载、传播和提供观看服务或者有其他侵犯中财国培在线培训平台知识产权的行为。否则，中财国培在线培训平台将追究侵权行为人的法律责任。<br />
        五、隐私保护<br />
        1、保护用户隐私是中财国培在线培训平台的一项基本政策，中财国培在线培训平台保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在中财国培在线培训平台的非公开内容，但下列情况除外：<br />
        1.1 事先获得用户的明确授权；<br />
        1.2 根据有关的法律法规要求；<br />
        1.3 按照相关政府主管部门的要求；<br />
        1.4 为维护社会公众的利益；<br />
        1.5 为维护中财国培在线培训平台的合法权益。<br />
        2、中财国培在线培训平台可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与中财国培在线培训平台同等的保护用户隐私的责任，则用户同意中财国培在线培训平台有权将用户的注册资料等提供给该第三方。<br />
        3、在不透露单个用户隐私资料的前提下，中财国培在线培训平台有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。<br />
        六、免责声明<br />
        1、用户明确同意其使用中财国培在线培训平台网络服务所存在的风险将完全由其自己承担；因其使用中财国培在线培训平台网络服务而产生的一切后果也由其自己承担，中财国培在线培训平台对用户不承担任何责任。<br />
        2、用户理解并确认，中财国培在线培训平台的产品与服务是按照现有技术和条件所能达到的现状提供的，中财国培在线培训平台无法保证其所提供的产品与服务毫无瑕疵，中财国培在线培训平台不对提供的产品与服务（含技术和信息）作出任何明示或暗示的承诺或保证，包括但不限于质量、稳定、正确、及时、完整、连贯、安全等，但中财国培在线培训平台承诺将不断提升服务质量及服务水平，为用户提供更加优质的服务。<br />
        3、中财国培在线培训平台不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由中财国培在线培训平台实际控制的任何网页上的内容，中财国培在线培训平台不承担任何责任。<br />
        4、为了改善用户体验、保证产品、服务的安全性及产品功能的一致性，中财国培在线培训平台可能会对软件进行更新。您应将软件更新到最新版本，否则中财国培在线培训平台并不保证其一定能正常使用。对于因不可抗力或中财国培在线培训平台不能控制的原因造成的网络服务中断或其它缺陷，中财国培在线培训平台不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。<br />
        5、用户同意，对于中财国培在线培训平台向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，中财国培在线培训平台无需承担任何责任：<br />
        5.1 中财国培在线培训平台向用户免费提供的各项网络服务；<br />
        5.2 中财国培在线培训平台向用户赠送的任何产品或者服务；<br />
        5.3 中财国培在线培训平台向收费网络服务用户附赠的各种产品或者服务。<br />
        七、违约赔偿<br />
        1、如因中财国培在线培训平台违反有关法律、法规或本协议项下的任何条款而给用户造成损失，中财国培在线培训平台同意承担由此造成的损害赔偿责任。<br />
        2、用户同意保障和维护中财国培在线培训平台及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给中财国培在线培训平台或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。<br />
        八、协议修改<br />
        1、中财国培在线培训平台有权随时修改本协议的任何条款，一旦本协议的内容发生变动，中财国培在线培训平台会直接在中财国培在线培训平台网站上公布修改之后的协议内容，该公布行为视为中财国培在线培训平台已经通知用户修改内容。中财国培在线培训平台也可通过其他适当方式向用户提示修改内容。<br />
        2、如果不同意中财国培在线培训平台对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受中财国培在线培训平台对本协议相关条款所做的修改。<br />
        九、通知送达<br />
        1、本协议项下中财国培在线培训平台对于用户所有的通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。<br />
        2、用户对于中财国培在线培训平台的通知应当通过中财国培在线培训平台对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。<br />
        十、法律管辖<br />
        1、本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。<br />
        2、如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向中财国培教育科技有限公司所在地人民法院提起诉讼。<br />
        十一、其他规定<br />
        1、本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。<br />
        2、如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
      </div>
    </el-dialog>
    <el-dialog width="50%" :visible.sync="dialogVisible2">
      <h3 style="font-size: 28px">中财国培在线培训平台隐私政策</h3>
      <span></span>
      <div>
        <p>
          您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应的安全保护措施，尽力保护您的个人信息安全可控。鉴于此，中财国培教育科技有限公司（下称“中财国培”，或简称“我们”）制定本《隐私政策》（下称“本政策/本隐私政策”)并提醒您：
        </p>
        <p>
          本政策适用于我方平台提供的所有产品和服务。您访问我方平台，使用我方平台提供的服务，及未设独立隐私政策的我方平台网站、服务器、及登录相关客户端，均适用本隐私政策。
        </p>
        <p>
          我们尽量以更清晰、更容易被您理解的方式展现本隐私保护政策，从而希望能够真实地传达我们希望向您传达的信息，并希望您在向我们提供某些信息（其中很可能包括您的个人信息）以及允许我们处理并分享某些信息之前，能够清晰地了解这些信息收集的目的、可能的用途以及其他方面的内容。
        </p>
        本隐私政策主要帮助您了解：<br />
        我们如何收集和使用您的个人信息？<br />
        我们会收集哪些数据？为什么收集这些数据？<br />
        我们会利用这些数据做什么以及如何保护这些数据等内容。<br />
        请您在使用我们服务之前，仔细阅读并了解本政策。如果您不同意本政策的内容，将导致我们无法为您提供完整的服务，同时也请您立即停止使用我们的产品或服务，若您继续使用我们的服务或产品，即表示您认可我们在本政策中的内容。<br />
        一、我们如何收集和使用您的个人信息<br />
        个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，包括但不限于自然人的姓名、出生日期、身份证件号码、电话号码等。<br />
        （一）您主动向我们提供的信息<br />
        1.您使用我们的特定产品和服务时，为满足向您提供产品和服务之目的，您需要在中财国培在线培训平台创建个人账号。创建账号时，您可能需要提供包括手机号码、电子邮箱及密码等在内的数据；创建账号后，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：姓名、教育/工作背景、身份证号/护照等。但您不提供上述信息，也不会影响您使用本服务的基本功能；特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。<br />
        2.您为了了解我们的产品及服务或参与活动而在浏览我们的网站时留下的回访信息，这些信息可能包括您的姓名、手机号码、电子邮箱、微信、QQ号、就读院校或职业等；在使用我方平台、我方平台服务进行观看时，可能会涉及披露自己的个人信息。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供、展示自己的信息。如您发现自己的个人信息泄露，尤其是您的账户或密码发生泄露，请您立即联系我方平台网站客服，采取相应措施。<br />
        公开信息是指您公开分享的任何信息，如您发表的评论、动态、视频，您的头像、昵称、用户名称等。<br />
        请注意，您在使用我们的服务时所共享的内容和信息，可能会涉及您的个人敏感信息。如果包含他人的个人信息，请您确认已获得他人的合法授权。请您更加谨慎地考虑，是否在使用我们的服务时披露甚至公开分享相关个人敏感信息。<br />
        3.您在创建个人账号后，可以在个人信息编辑处自行选择上传、设置、修改或完善相关个人信息，具体包括：手机号码、电子邮箱、登录密码等；<br />
        4.您在购买我们的产品或服务中准备消费支付时，需要主动向我们提供的相关个人信息，例如姓名、性别、工作单位、电子邮箱、手机号、身份证件号码、密码、年龄、银行卡号、交易账单信息、发票开具信息、备注信息等；<br />
        5.您在使用我们的客服、产品或服务的售后功能时，主动向我们提供的账户相关信息、交易账单信息及您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）及其他信息。如您拒绝提供可能导致您无法使用我们的客服用户响应机制。<br />
        您所提供的信息，将在您使用本服务期间持续授权为我们使用；在您注销账号时，我们将停止使用并删除这些信息。<br />
        克风权限。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用平台的其他功能。<br />
        6.您使用我们的搜索服务时，会收集您的搜索关键字信息、日志记录。为了提供高效的搜索服务，部分前述信息会暂时存储在您的本地存储设备之中，并可向您展示搜索结果内容、搜索历史记录。<br />
        7.在一些线下推广活动中，我们（或我们的关联方、合作方）的工作人员可能会分发一些宣传资料并在为您提供产品及服务咨询时留存的您的个人信息，这些信息可能包括您的姓名、手机号码、电子邮箱、工作单位等。<br />
        （二）我们自动获取的您的信息<br />
        为了更好地为您提供内容推荐展示，对搜索结果进行优化，了解产品对不同硬件设备适配性、确保操作环境安全、识别账号异常状态等用途，我们会收集关于您对我们产品或服务使用方式的信息，并将这些信息进行关联，这些信息包括：<br />
        1.日志信息。当您使用中财国培在线培训平台产品和服务时，我们的服务器会自动记录一些信息，例如您对我们的产品和/或服务的使用情况、IP地址、所访问服务的URL、浏览器的类型和使用的语言、与通讯软件通讯的信息以及访问服务的日期、时间及学习信息，包含：基础知识信息、测验结果、做题结果、学习时长、学习偏好等。<br />
        这可能导致我们会根据您的学习需求、习惯和偏好向您推送广告、介绍课程及相关服务，我们会尽量在满足您需求的情况控制推送频率。<br />
        请您理解，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。<br />
        为向您提供更便捷、更符合您个性化需求的信息展示、搜索及推送服务，我们会根据您的设备信息和服务日志信息，提取您的偏好特征，并基于特征标签产出间接人群画像，用于展示、推送信息。<br />
        此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。<br />
        我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务是我们的核心目标。为实现安全保障功能所收集的信息是必要信息。<br />
        2.依法豁免征得同意收集和使用的个人信息<br />
        请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：<br />
        (1) 与国家安全、国防安全有关的；<br />
        (2) 与公共安全、公共卫生、重大公共利益有关的；<br />
        (3) 与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；<br />
        (4)
        出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
        (5) 您自行向社会公众公开的个人信息；<br />
        (6)
        从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。<br />
        (7) 根据与您签订和履行相关协议或其他书面文件所必需的；<br />
        (8)
        用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；<br />
        (9) 为合法的新闻报道所必需的；<br />
        (10)
        学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br />
        (11) 法律法规规定的其他情形。<br />
        二、我们如何使用 Cookie 和同类技术<br />
        <p>
          为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储Cookie、Flash
          Cookie或浏览器或关联应用程序提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称“Cookie”）。借助于
          Cookie，网站能够存储您的偏好或购物车内的商品等数据。
        </p>
        <p>
          我们不会将Cookie用于本政策所述目的之外的任何用途，您可根据自己偏好管理进行操作，大部分浏览器上都设有阻止Cookie的功能。如果您的浏览器或浏览器附加服务允许，您可修改对Cookie的接受程度或拒绝我们的Cookie。但如果您这么做，在某些情况下可能会影响您安全访问我们的网站，且可能需要在每一次访问我们的网站时更改用户设置。
        </p>
        三、我们如何共享、转让、公开披露您的个人信息<br />
        除下列情形外，我们不会与任何其他第三方共享您的个人信息<br />
        （一）共享和披露<br />
        1.在获得您的明确同意或授权或您主动选择的情况下共享。获得您的授权或明确同意后，我们会与其他公司、组织和个人分享您的个人信息。例如，如果我们委托第三方向您提供产品或服务（如用户活动、抽奖奖品寄送、积分兑换奖品时），我们会在征得您同意后将上述信息共享给第三方，如果您拒绝提供此类信息，我们将无法完成相关交付服务。只有您选择同意，我们才会共享您的个人敏感信息。获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息。<br />
        2.
        在法定情形下的共享和披露。我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。例如如果我们确定您出现违反法律法规或严重违反我方平台相关协议规则的情况，或为保护我方平台网站及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或我方平台相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及我方平台已对您采取的措施。例如，若您或您使用的账号上传非法视频、违规视频而严重违反我方平台规则、触犯法律法规和/或违背公序良俗，造成重大社会影响，给我方平台造成声誉损失，我们可能会披露您的信息与处罚情况。<br />
        3.
        向我方的关联方分享您的个人信息。与关联公司间共享：为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的信息或保护我方关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息（如为便于您使用我方账号登录并使用我们关联公司产品或服务，我们会向关联公司共享您必要的个人信息），且受本隐私权政策中所声明目的的约束。如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。<br />
        4.
        与授权合作伙伴共享。我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不得将此信息用于其他任何目的。<br />
        目前，我们的授权合作伙伴包括以下类型：<br />
        （1）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴共享。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。<br />
        （2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴（如互联网电视播控牌照方、内容牌照方、硬件厂商、电信运营商等），这些支持包括我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。<br />
        5.协助处理争议。如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。例如您在我方平台上创建的某一文字图片或视频内容被指控知识产权侵权或内容违规，如交易任何投诉一方、司法机构或行政执法机构提出信息披露请求的，我方会视情况向该上述机构提供被投诉用户的联络方式等必要信息，以促成交纠纷的解决。我方平台仅在法律有明确规定的情况下承担相应的法律责任。<br />
        （二）转让<br />
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br />
        1.在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；<br />
        2.在我方平台服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意；<br />
        3.满足法律法规、法律程序的要求或强制性的政府要求或司法裁定。<br />
        （三）共享、转让、披露个人信息时事先征得授权同意的例外<br />
        以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：<br />
        1.与国家安全、国防安全有关的； <br />
        2.与公共安全、公共卫生、重大公共利益有关的； <br />
        3.与犯罪侦查、起诉、审判和判决执行等有关的； <br />
        4.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
        5.您自行向社会公众公开的个人信息；<br />
        6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；<br />
        7.法律法规规定的其他情形。<br />
        根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。<br />
        如您不同意我们按照上述条款向第三方提供您的个人信息，请您立即停止使用我方平台服务。<br />
        四、我们如何存储个人信息<br />
        （一）信息存储的地点：<br />
        我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：<br />
        1.法律法规有明确规定；<br />
        2.获得您的明确授权；<br />
        针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。<br />
        （二）信息存储期限：<br />
        我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。而我们判断前述期限的标准包括：<br />
        1、完成与您相关的服务目的、维护相应服务及业务记录、应对您可能的查询或投诉；<br />
        2、保证我们为您提供服务的安全和质量；<br />
        3、您是否同意更长的留存期间；<br />
        4、是否存在保留期限的其他特别约定。<br />
        在您的个人信息超出保留期限后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。<br />
        （三）信息删除和匿名化处理<br />
        如本平台服务决定停止运营时，我们将在相关服务停止运营后停止继续收集您的个人信息。我们将以公告形式将停止运营通知向您送达。对已持有的您的个人信息将进行删除或匿名化处理。涉及儿童个人信息的，我们会并将停止运营的通知及时告知儿童监护人。<br />
        五、我们如何保护您的个人信息安全<br />
        1.我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。<br />
        2.我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。<br />
        3.我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。<br />
        4.尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。<br />
        5.请注意互联网并非绝对安全的环境。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息透露给他人。<br />
        6.我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的影响和后果扩大。在不幸发生个人信息安全事件（泄露、丢失）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以推送通知、邮件、信函、短信及相关形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。<br />
        六、管理您的个人信息<br />
        我们按《中华人民共和国网络安全法》的要求，通过提供便捷的方法，让您可以访问、更正及删除自己的账户信息或使用我们的服务时您提供的其他个人信息。您可以通过如下方式访问及管理您的个人信息：<br />
        1.个人信息主体注销账户<br />
        您可以通过联系我们的客服或通过其他我们公示的联系方式注销您的账号（但法律法规另有规定的除外）。请注意：一旦您注销账号，将无法使用我们提供的产品服务，因此请您谨慎操作。我们为了保护您或他人的合法权益会结合您对我们提供的各产品的使用情况判断是否支持您的注销请求，比如您还有课程未完结，我们会提示您先进行相应的操作。注销账号后，您该账户内的所有信息将被清空，并根据您的要求删除您的个人信息。<br />
        我们尽全力保护您对于您个人信息的查询、访问、修改、删除、撤回同意授权、注销账号、投诉举报以及设置隐私功能的相关权利，以使您有能力保障您的隐私和信息安全<br />。
        2.访问您的个人信息<br />
        您可以随时登录您的个人账号，访问或编辑您的账号中的个人资料信息、更改您的密码、添加安全信息、身份认证等。<br />
        3.更正或补充您的个人信息<br />
        经对您的身份进行验证，且更正不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或更新，您可以自行在我们的网站中进行更正，或在特定情况下，尤其是数据错误时，通过本政策文末提供的联系方式将您的更正申请提交给我们，要求我们更正或更新您的数据，但法律法规另有规定的除外。但出于安全性和身份识别的考虑，您可能无法修改注册时提交的某些初始注册信息。<br />
        4.更改或撤销您的授权<br />
        如您想更改相关功能的授权范围（例如位置、通讯录、相机），您可以通过您的硬件设备修改个人设置、或在我们的产品或服务中的相关功能设置界面进行操作处理。如您在此过程中遇到操作问题的，可以通过本政策文末提供的方式联系我们。
        当您取消相关个人信息收集的授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但您知悉并同意，除非您行使前述"删除权"，否则您的该行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。<br />
        5.提前获知产品和服务停止运营权<br />
        我们愿一直陪伴您，若因特殊原因导致我们部分或全部产品和服务被迫停止运营，我们将提前在产品或服务的主页面或站内信或向您发送电子邮件或其他合适的能触达您的方式通知您，并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理等，法律法规另有规定的除外。<br />
        七、未成年人条款<br />
        1.若您是未满18周岁的未成年人，在使用中财国培在线培训平台产品及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。
        2.我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、储存、共享、转让或披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息；如果监护人发现我们在未获得监护人同意情况下收集了未成年人个人信息，请通过本政策第九条联系我们，我们会设法尽快删除相关数据。<br />
        八、隐私政策的修订和通知<br />
        我方有权修改隐私政策并在修订生效前通过我方平台公告或以其他适当方式通知您。该等情况下，若您继续使用我们的服务，即表示同意受经修订的我方平台隐私权政策的约束。<br />
        未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会发布对隐私权政策所做的任何变更和更新。
        对于重大变更，我们还会提供更为显著的通知（包括我们会通过我方平台公示的方式进行通知甚至向您提供弹窗提示）。<br />
        本政策所指的重大变更包括但不限于：<br />
        1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br />
        2.我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；<br />
        3.个人信息共享、转让或公开披露的主要对象发生变化；<br />
        4.您参与个人信息处理方面的权利及其行使方式发生重大变化；<br />
        5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<br />
        6.个人信息安全影响评估报告表明存在高风险时。<br />
        九、如何联系我们<br />
        如您对本隐私政策或其他相关事宜有疑问，请及时与我们联系，您可将问题发送至我们的联系邮箱zhongcaiguopei@cfefe.com或将信件寄到如下地址：北京市西城区月坛南街月新大厦6层614或者电话联系
        010-88583040。我们将在验证您的用户身份和了解相关情况后十五日内予以回复。
      </div>
    </el-dialog>
    <div class="kf">
      <div class="kf-list">
        <img
          src="../../assets/image/qr5.jpeg"
          height="150px"
          width="150px"
          alt=""
        />
        <p>微信扫码进入政采家</p>
      </div>
      <div class="kf-list">
        <img
          src="../../assets/image/qr6.jpeg"
          height="150px"
          width="150px"
          alt=""
        />
        <p>微信扫码关注公众号</p>
      </div>

      <div class="kf-list">
        <img
          src="http://guopei-jxjy.hcinfos.cn/float/fl_contact.png"
          height="150px"
          width="150px"
          alt=""
        />
        <p>微信扫码联系客服</p>
      </div>
      <div class="zhibo kf-list" v-for="item in broadcast" :key="item.liveId">
        <img :src="item.liveLogo" height="150px" width="150px" alt="" />
        <p>{{ item.liveName }}</p>
        <div class="btons" @click="goBrode(item)">进入</div>
      </div>

      <div class="certificat" @click="caertde">证书查询</div>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import cookie from "@/api/cookie";
import { MessageBox } from "element-ui";

export default {
  name: "index",
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    const validateChecked = (rule, value, callback) => {
      if (value === false) {
        callback(new Error("请接受用户注册协议"));
      } else {
        callback();
      }
    };
    return {
      active: "账户登录",
      actives: "首页",
      head: [
        {
          name: "首页",
          isrout: true,
          url: "/index",
        },
        {
          name: "集团简介",
          isrout: false,
          url: "http://www.cfemg.cn/",
        },
        {
          name: "培训项目",
          isrout: true,
          url: "/train",
        },
        {
          name: "杂志征订",
          isrout: false,
          url: "https://shop19440678.m.youzan.com/v2/showcase/homepage?alias=6kqgub8o",
        },
        {
          name: "面授培训",
          isrout: false,
          url: "https://zczzs.pxbmzx.cn",
        },
      ],
      message: "",
      message2: "",
      show: false,
      show2: false,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogVisible: false,
      dialogVisible2: false,
      form: {
        userMobile: "",
        code: "",
        password: "",
        password2: "",
        sessionId: "",
        userName: "",
        checked: false,
      },
      rules: {
        userMobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password2: [{ validator: validatePass2, trigger: "blur" }],
        userName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        userCompany: [
          { required: true, message: "请输入工作单位", trigger: "blur" },
        ],
        userEmail: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
        ],
        userGender: [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
        checked: [{ validator: validateChecked, trigger: "change" }],
      },
      form2: {
        userName: "",
        password: "",
        checked: false,
      },
      rules2: {
        userName: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      form3: {
        userMobile: "",
        code: "",
        sessionId: "",
        checked: false,
      },
      rules3: {
        userMobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      broadcast: [], //直播间的数据
      loginLoading: false,
    };
  },
  mounted() {
    console.log("我没触发mounted？？");
    this.getLabe();
    this.$store.commit("setUser");
    this.$store.dispatch("setUserInfo");
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    getLabe() {
      api
        .getliveList({
          page: 1,
          size: 20,
        })
        .then((res) => {
          console.log(res.data.list, "我是直播间数据");
          this.broadcast = res.data.list;
        })
        .catch((res) => {
          console.log(res, "我直播间宝错了");
        });
    },

    goOld() {
      MessageBox.confirm("老版本只用来登录打印证书使用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          window.open("http://jxjy-old.cfefe.com");
        })
        .catch();
    },
    getCode() {
      if (!this.form.userMobile) {
        return this.$message.error("请输入手机号");
      }
      let second = 60;
      const timer = setInterval(() => {
        second--;
        if (second) {
          this.message = `${second}s`;
        } else {
          clearInterval(timer);
          // 手动清除 Toast
          this.show = false;
        }
      }, 1000);
      api.send(this.form.userMobile).then((res) => {
        this.form.sessionId = res.data;
      });
      this.show = !this.show;
    },
    getCode2() {
      let second = 60;
      const timer = setInterval(() => {
        second--;
        if (second) {
          this.message2 = `${second}s`;
        } else {
          clearInterval(timer);
          // 手动清除 Toast
          this.show2 = false;
        }
      }, 1000);
      api.send(this.form3.userMobile).then((res) => {
        this.form3.sessionId = res.data;
      });
      this.show2 = !this.show2;
    },
    signUp(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // eslint-disable-next-line no-unused-vars
          api.register(this.form).then((res) => {
            console.log(res.data);
            this.$message.success("注册成功！");
            this.form = {};
            this.dialogFormVisible = false;
          });
        } else {
          return false;
        }
      });
    },
    signIn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginLoading = true;
          api
            .login(this.form2)
            .then((res) => {
              if (res.code === 200) {
                cookie.setCookie("userId", res.data.user.userId);
                cookie.setCookie("token", res.data.token.id);
                this.$store.commit("setUser");
                this.$store.dispatch("setUserInfo");
                this.$message.success("登录成功！");
                this.form2 = {};
                this.dialogFormVisible2 = false;
              }
            })
            .finally(() => {
              this.loginLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    kjSignIn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api.signIn(this.form3).then((res) => {
            if (res.code === 200) {
              cookie.setCookie("userId", res.data.user.userId);
              cookie.setCookie("token", res.data.token.id);
              this.$store.commit("setUser");
              this.$store.dispatch("setUserInfo");
              this.$message.success("登录成功！");
              this.form3 = {};
              this.dialogFormVisible2 = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    login() {
      this.dialogFormVisible = false;
      this.dialogFormVisible2 = true;
    },
    register() {
      this.dialogFormVisible2 = false;
      this.dialogFormVisible = true;
    },
    forget() {
      this.$router.push("/forget");
      this.dialogFormVisible2 = false;
    },
    logout() {
      cookie.removeCookie("userId");
      cookie.removeCookie("token");
      this.$store.commit("setUser");
      this.$router.push("/");
    },
    look() {
      this.dislogFormVisible = false;
      this.dialogVisible = true;
    },
    look2() {
      this.dislogFormVisible = false;
      this.dialogVisible2 = true;
    },
    // 点击heade
    gos(row) {
      if (row.isrout) {
        this.actives = row.name;
        this.$router.push(row.url).catch((err) => {
          console.log("报错", err);
        });
        return;
      }
      window.open(row.url);
    },
    // 直播间跳转
    goBrode(row) {
      console.log(row, "我无语了");
      if (!this.user) {
        return this.$message.error("请登录");
      }
      if (row.liveType == "0") {
        this.$router.push({
          path: "/broadcast",
          query: {
            liveUrl: row.liveUrl,
            liveName:row.liveName
          },
        });
      } else {
        api
          .getLiveID({
            userId: this.user.userId,
            liveId: row.liveId,
          })
          .then((res) => {
            if (res.data.length == 0) {
              return this.$message.error("当前直播间无权限,需购买课程后观看");
            }
            this.$router.push({
              path: "/broadcast",
              query: {
                liveUrl: row.liveUrl,
                liveName:row.liveName
              },
            });
          });
      }
    },
    // 正式验真伪
    caertde() {
      this.$router.push({
        path: "/certificat",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$main-color: #dc2325;
.container {
  display: flex;
  flex-direction: column;

  .header {
    background: #ffffff;
    opacity: 0.8;
    z-index: 999;
    .headCon {
      width: 1600px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .hand {
        // width: 1200px;
        height: 98px;
        line-height: 98px;
        display: flex;
        justify-content: space-between;
        // margin: 0 auto;
        .go-old {
          margin-left: 230px;
          button {
            border: none;
            width: 150px;
            height: 40px;
            outline: none;
            background: linear-gradient(90deg, red, #dc2325);
            color: #fff;
            font-size: 15px;
            cursor: pointer;
          }
        }
        .logo {
          img {
            vertical-align: middle;
          }
        }
      }

      .headRight {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .info {
          display: flex;
          align-items: center;

          font-size: 14px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          color: #888888;
          line-height: 20px;

          .user {
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-right: 20px;

            img {
              margin-right: 10px;
            }
          }

          .message {
            display: flex;
            align-items: center;
            margin-right: 20px;

            img {
              margin-right: 10px;
            }
          }

          .logout {
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
              margin-right: 10px;
            }
          }
        }
        .infos {
          font-size: 14px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          color: #888888;
          line-height: 20px;
        }
      }
    }
  }

  .nav-bar {
    // background-color: $main-color;
    margin-right: 40px;
    .nav {
      // width: 1200px;
      // height: 45px;
      // margin: 0 auto;
      display: flex;
      list-style: none;
      li {
        width: 120px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        cursor: pointer;
        a {
          color: #333333;
        }
      }
      .actives {
        background: rgba(38, 79, 153, 1);
        a {
          color: #ffffff;
        }
      }

      .el-menu-item.is-active {
        background-color: #fff !important;
      }

      .el-menu--horizontal > .el-menu-item.is-active {
        border-bottom: none;
      }
    }
  }

  .active {
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    color: #264f99;
    position: relative;
    cursor: pointer;
  }
  .active::after {
    display: block;
    content: "";
    width: 40px;
    height: 4px;
    background: #264f99;
    border-radius: 2px;
    position: absolute;
    bottom: -13px;
    left: 19px;
  }

  .active2 {
    color: #999999;
    font-size: 20px;
    cursor: pointer;
  }

  .footer {
    // margin-top: 10px;
    background-color: #14171a;
    .footer-content {
      // display: flex;
      // justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      padding: 40px 0px 30px;
      .left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;
        .title {
          margin: 0px;
          height: 25px;
          font-size: 18px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          color: #ffffff;
          line-height: 25px;
          margin-bottom: 10px;
        }
        ul {
          list-style: none;
          margin: 0px;
          display: flex;
          align-items: center;
          padding: 0px;
          li {
            position: relative;
            padding: 0px 14px;
            a {
              color: RGBA(169, 169, 169, 1);
              font-size: 14px;
              font-weight: 400;
              font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
              font-weight: 400;
              line-height: 30px;
            }
          }
          li::after {
            content: ""; /* 必须有content属性才能显示伪元素 */
            display: block; /* 转换成块级元素 */
            position: absolute; /* 让盒子相对于.box进行定位 */
            top: 8px; /* 放置在.box的底部 */
            right: 0;
            width: 2px;
            height: 16px;
            background-color: RGBA(192, 192, 192, 1);
          }
          li:last-child::after {
            content: "";
            display: none;
          }
        }
      }

      .qrcon {
        display: flex;
        justify-content: center;
        .qr {
          display: flex;
          flex-direction: column;
          text-align: center;
          margin-right: 38px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            display: block;
            margin-bottom: 10px;
          }

          span {
            font-size: 12px;
            font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
            font-weight: 400;
            color: RGBA(169, 169, 169, 1);
            line-height: 16px;
          }
        }
        .qr:last-child {
          margin: 0px;
        }
      }
    }
  }

  .filings {
    background: RGBA(38, 79, 153, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    span {
      height: 17px;
      font-size: 12px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #ffffff;
      line-height: 17px;
    }
  }
}

.el-dialog {
  border-radius: 12px;
}

.kf {
  position: fixed;
  z-index: 10;
  top: 170px;
  right: 0;
  background: #fff;
  padding: 10px;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,
    rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
  .kf-list {
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 140px;
      height: 140px;
    }
    p {
      margin: 0px;
      font-size: 14px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #222222;
      line-height: 18px;
    }
  }

  .zhibo {
    background: rgba(235, 241, 250, 1);
    padding: 20px 20px;
    img {
      width: 50px;
      height: 50px;
      border-radius: 6px;
    }
    p {
      margin: 16px 0px 10px;
      font-size: 18px;
      max-width: 120px;
      line-height: 1.2;
    }
    .btons {
      width: 100%;
      height: 24px;
      background: #ffffff;
      font-size: 14px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #264f99;
      line-height: 24px;
      cursor: pointer;
    }
  }
}

.kf img {
  display: block;
}

.finso {
  .resf {
    color: #673ab7;
  }
  p {
    padding: 0px;
    margin: 0px;
  }
}

.certificat {
  margin-top: 20px;
  color: #ffffff;
  background: #264f99;
  border-radius: 6px;
  cursor: pointer;
  height: 36px;
  line-height: 36px;
}
</style>
